import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { individualsService, UpdateIndividualRequest } from '@aslanpay/portal-common-lib';

const useUpdateIndividual = ({
  onSuccess,
  onError,
}: UseMutationOptions<unknown, Error, UpdateIndividualRequest>) => {
  return useMutation<unknown, Error, UpdateIndividualRequest>(
    ({
      id,
      firstName,
      lastName,
      email,
      additionalEmail,
      role,
      phoneNumber,
      externalPayrollId,
      jobTitle,
      annualGrossSalary,
      globalAllowancePercentage,
      odpAllowancePercentage,
      payCalendarId,
      startDate,
      terminationDate,
      allowTracking,
      allowMarketing,
      canTopUpCompanyPoints,
      salaried,
    }: UpdateIndividualRequest) =>
      individualsService.updateIndividual({
        id,
        firstName,
        lastName,
        email: email.toLowerCase(),
        additionalEmail: additionalEmail?.toLowerCase(),
        role,
        phoneNumber: phoneNumber?.split(' ').join(''),
        externalPayrollId,
        // The individual update endpoint is a full replace — company-manager nulls any field the
        // body leaves out. jobTitle is not editable here, so it must be echoed back unchanged.
        jobTitle,
        annualGrossSalary,
        globalAllowancePercentage,
        odpAllowancePercentage,
        payCalendarId,
        startDate,
        terminationDate,
        allowTracking,
        allowMarketing,
        canTopUpCompanyPoints,
        salaried,
      }),
    { onSuccess, onError }
  );
};

export default useUpdateIndividual;
